export const videoCallPromo = {
  headline: "気になる女の子とビデオ通話をしてみませんか？",
  body: "気になる女の子と今すぐ顔を見て話せます。",
  cta: "女の子を探す",
  close: "閉じる",
} as const;
